export enum TaskTab {
    comments = 0,
    timeEntries = 1,
    bugs = 2,
    toDo = 3,
    related = 5
}
